import Vue from "vue";
import VueRouter from "vue-router";
import LoginPage from "@/views/loginPage/loginPage.vue";
import InIt from "@/views/init/init.vue";
import Index from "@/views/index/index.vue";
import Layout from "@/views/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/loginPage",
    name: "loginPage",
    component: LoginPage,
  },
  {
    path: "/init",
    name: "init",
    component: InIt,
  },
  {
    path: "/index",
    name: "index",
    component: Index,
  },
  {
    path: "/layout",
    name: "layout",
    component: Layout,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
